import * as React from 'react';
import type { AssetId } from 'owa-timestream-types';
import { observer } from 'mobx-react-lite';
import { sortChildAssets, ORDER_MAX } from 'owa-timestream-asset-sdk-bucket';
import { useProjectId } from 'owa-timestream-asset-sdk';
import BucketChildView from './BucketChildView';

export default observer(function BucketChildren({ childrenAssets }: { childrenAssets: AssetId[] }) {
    const projectId = useProjectId();
    const assets = sortChildAssets(projectId, childrenAssets);
    const lastN = assets.length - 1;

    return (
        <>
            {assets.map(({ id, type, order }, n) => {
                const minOrder = n == 0 ? -ORDER_MAX : assets[n - 1].order + 1;
                const maxOrder = n == lastN ? ORDER_MAX : assets[n + 1].order - 1;
                return (
                    <BucketChildView
                        key={id}
                        childId={id}
                        childType={type}
                        childOrder={order}
                        minOrder={minOrder}
                        maxOrder={maxOrder}
                    />
                );
            })}
        </>
    );
});
